import { isAuthenticated } from "./authHelper";
import { getAdminClientCreds, getBasicAdminDetails } from "./backend_helper";
import { decryptDataFromArray, encryptDataToArray } from "./EncDec";

const moment = require("moment");

const getPartnerSettingsKey = (
  prefix = "",
  vehicleLabel = "NeuroTal Trust"
) => {
  if (!(prefix && vehicleLabel)) {
    return "";
  }

  let keyString = prefix?.toLowerCase();

  vehicleLabel = (vehicleLabel || "")
    ?.split(/[ -]/)
    ?.filter(data => data)
    ?.join("_")
    ?.toLowerCase();

  keyString += `_${vehicleLabel}`;

  return keyString;
};

const getReferralInvestmentSettingsKey = vehicleLabel => {
  return getPartnerSettingsKey("referral_investment_amount_fee", vehicleLabel);
};

const getSelfInvestmentSettingsKey = vehicleLabel => {
  return getPartnerSettingsKey("self_investment_amount_fee", vehicleLabel);
};

const getSyndicatePayoutSettingsKey = vehicleLabel => {
  return getPartnerSettingsKey("syndicate_payout_fee", vehicleLabel);
};

const formatNumberToCommaSeparatedString = (
  amount = 0,
  currency = {
    value: "INR",
    locale: "en-IN",
  }
) => {
  try {
    if (!amount) {
      return 0;
    }

    if (Number(amount).toString() === "NaN") {
      return amount.toString();
    }

    let formatter = new Intl.NumberFormat(currency?.locale || "en-IN", {});

    let formattedValue = formatter.format(amount);

    if (formattedValue === "NaN") {
      formattedValue = amount?.toString();
    }

    return formattedValue;
  } catch (error) {
    // console.trace(error);
    return amount.toString();
  }
};

const formatNumberToCommaSeparatedCurrency = (
  amount = 0,
  currency = {
    value: "INR",
    locale: "en-IN",
  }
) => {
  try {
    if (!amount) {
      return 0;
    }

    if (Number(amount).toString() === "NaN") {
      return amount.toString();
    }

    let formatter = new Intl.NumberFormat(currency?.locale || "en-IN", {
      style: "currency",
      currency: currency?.value || "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    let formattedValue = formatter.format(amount);

    if (formattedValue === "NaN") {
      formattedValue = amount?.toString();
    }

    return formattedValue;
  } catch (error) {
    // console.trace(error);
    return amount.toString();
  }
};

const formatNumberToStringWithCurrency = (
  amount = 0,
  currency = {
    value: "INR",
    locale: "en-IN",
  }
) => {
  try {
    if (!amount) {
      return 0;
    }

    if (Number(amount).toString() === "NaN") {
      return amount.toString();
    }

    let options = {
      style: "currency",
      currency: currency?.value || "INR",
      notation: "compact",
      minimumSignificantDigits: 2,
      maximumSignificantDigits: 3,
      // minimumFractionDigits: 2,
      // maximumFractionDigits: 3,
      // compactDisplay: "long",
      // currencyDisplay: "name",
    };

    let formatter = new Intl.NumberFormat(currency?.locale || "en-IN", options);

    let formattedValue = formatter.format(amount);

    if (formattedValue === "NaN") {
      formattedValue = amount?.toString();
    }

    return formattedValue;
  } catch (error) {
    // console.trace(error);
    return amount.toString();
  }
};

const getNumberOfParticipantsOptions = () => {
  // total 9 slot booked for moderators
  const listofOptions = [
    {
      label: "up to 20",
      value: 11,
    },
    {
      label: "up to 50",
      value: 41,
    },
    {
      label: "up to 100",
      value: 91,
    },
    {
      label: "up to 250",
      value: 241,
    },
    {
      label: "up to 500",
      value: 491,
    },
  ];
  return listofOptions;
};
const formatNumberToStringWithCurrencyWithoutSymbol = (
  amount = 0,
  currency = {
    value: "INR",
    locale: "en-IN",
  }
) => {
  try {
    if (!amount) {
      return 0;
    }

    if (Number(amount).toString() === "NaN") {
      return amount.toString();
    }

    let options = {
      // style: "currency",
      currency: currency?.value || "INR",
      notation: "compact",
      minimumSignificantDigits: 2,
      maximumSignificantDigits: 3,
      // minimumFractionDigits: 2,
      // maximumFractionDigits: 3,
      // compactDisplay: "long",
      // currencyDisplay: "name",
    };

    let formatter = new Intl.NumberFormat(currency?.locale || "en-IN", options);

    let formattedValue = formatter.format(amount);

    if (formattedValue === "NaN") {
      formattedValue = amount?.toString();
    }

    return formattedValue;
  } catch (error) {
    // console.trace(error);
    return amount.toString();
  }
};

const getInterviewStatus = status => {
  status = parseInt(status) || 0;
  // comment: '0-pending,1-scheduled,2-skipped,3-onhold,4-shortlisted',
  if (status == 0) {
    return "Pending";
  } else if (status === 1) {
    return "Scheduled";
  } else if (status === 2) {
    return "Skipped";
  } else if (status === 3) {
    return "On Hold";
  } else if (status === 4) {
    return "Completed";
  } else if (status === 5) {
    return "Shortlisted";
  } else if (status === 6) {
    return "Not Attempted";
  }
  return "Pending";
};

const getRangeDateTimeString = (d1, d2, offset) => {
  if (!d1 || !d2 || d1?.getFullYear() === 1970 || d2?.getFullYear() === 1970) {
    return "-";
  }
  if (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  ) {
    return `${moment(d1).utc().add(offset).format("Do MMM'YYYY")}, ${moment(d1)
      .utc()
      .add(offset)
      .format("hh:mm A")} - ${moment(d2).utc().add(offset).format("hh:mm A")}`;
  }
  return `${moment(d1)
    .utc()
    .add(offset)
    .format("Do MMM'YYYY, hh:mm A")} - ${moment(d2)
    .utc()
    .add(offset)
    .format("Do MMM'YYYY, hh:mm A")}`;
};

const getFilterStatus = st => {
  // comment: '1=TestFilters,2=InterviewFilters,3=OfferLetterFilters'
  let filterStatus = [];
  if (st === 1 || st === 2) {
    filterStatus = [
      { value: "0", label: "Pending" },
      { value: "1", label: "Scheduled" },
      { value: "2", label: "Skip" },
      { value: "3", label: "On Hold" },
      { value: "4", label: "Completed" },
      { value: "5", label: "Shortlisted" },
      { value: "6", label: "Not Attempted" },
    ];
  }
  if (st === 3) {
    filterStatus = [
      { value: "0", label: "Pending" },
      { value: "1", label: "Approved" },
      { value: "2", label: "Rejected" },
    ];
  }
  if (st === 4) {
    filterStatus = [
      { value: "0", label: "No Action Taken" },
      { value: "1", label: "Onboarding Request Sent" },
      { value: "2", label: "Onboarded" },
    ];
  }

  if (st === 5) {
    filterStatus = [
      { value: "SSC (10th Pass)", label: "SSC (10th Pass)" },
      { value: "Inter (10+2)", label: "Inter (10+2)" },
      {
        value: "Graduate (any science degree)",
        label: "Graduate (any science degree)",
      },
      {
        value: "Graduate (any other degree)",
        label: "Graduate (any other degree)",
      },
      {
        value: "Post Graduate (any science degree)",
        label: "Post Graduate (any science degree) ",
      },
    ];
  }

  if (st === 6) {
    filterStatus = [
      { value: "Level 1", label: "Level 1" },
      { value: "Level 2", label: "Level 2" },
      { value: "Level 3", label: "Level 3" },
      { value: "Level 4", label: "Level 4" },
      { value: "Level 5", label: "Level 5" },
      { value: "Level 6", label: "Level 6" },
      { value: "Level 7", label: "Level 7" },
      { value: "Level 8", label: "Level 8" },
      { value: "Level 9", label: "Level 9" },
      { value: "Level 10", label: "Level 10" },
    ];
  }

  return filterStatus;
};

const bytesToMB = bytes => {
  return bytes / (1024 * 1024);
};

export const VALUE_SEPARATOR = "=||=";

const fetchBasicAdminDetails = async () => {
  try {
    if (!isAuthenticated()) return;

    let response = await getBasicAdminDetails();
    response = decryptDataFromArray(response);

    const userInfo = response?.data;
    const oldAuthUser = JSON.parse(localStorage.getItem("authUser")) || {};

    oldAuthUser.user = {
      ...(oldAuthUser.user || {}),
      ...(userInfo || {}),
    };

    localStorage.setItem("authUser", JSON.stringify(oldAuthUser));
    localStorage.setItem("user_info", JSON.stringify(oldAuthUser.user));
  } catch (error) {
    console.error(error);
  }
};


const fetchAdminClientCreds = async companyID => {
  try {
    let response = await getAdminClientCreds(companyID);

    let clientCredentials = decryptDataFromArray(response?.data);

    clientCredentials = encryptDataToArray(clientCredentials);

    localStorage.setItem("client_company", JSON.stringify(clientCredentials));
  } catch (error) {}
};

const renderQualificationWithSpecialization = (qualification, specializationMap) => {
  if (!qualification) return "—";

  // 1️⃣ Split & normalize
  const qualifications = qualification
    .split(",")
    .map(q => q.trim());

  return (
    <div>
      {qualifications.map((q, index) => {
        const specialization = specializationMap?.[q];

        return (
          <div key={index} style={{ marginBottom: "6px" }}>
            <div>{q}</div>

            {specialization && (
              <div style={{ fontSize: "12px", color: "#6c757d" }}>
                Specialization: <strong>{specialization}</strong>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// Country-based phone validation rules (by country name/label)
const phoneValidationRules = {
  // India - 10 digits, starts with 6-9
  "India": { pattern: /^[6-9]\d{9}$/, minLength: 10, maxLength: 10, message: "Indian mobile number must be 10 digits and start with 6-9" },
  // USA - 10 digits
  "United States": { pattern: /^\d{10}$/, minLength: 10, maxLength: 10, message: "US mobile number must be 10 digits" },
  "United States of America": { pattern: /^\d{10}$/, minLength: 10, maxLength: 10, message: "US mobile number must be 10 digits" },
  "USA": { pattern: /^\d{10}$/, minLength: 10, maxLength: 10, message: "US mobile number must be 10 digits" },
  // UK - 10-11 digits
  "United Kingdom": { pattern: /^\d{10,11}$/, minLength: 10, maxLength: 11, message: "UK mobile number must be 10-11 digits" },
  "UK": { pattern: /^\d{10,11}$/, minLength: 10, maxLength: 11, message: "UK mobile number must be 10-11 digits" },
  // UAE - 9 digits
  "United Arab Emirates": { pattern: /^\d{9,10}$/, minLength: 9, maxLength: 10, message: "UAE mobile number must be 9-10 digits" },
  "UAE": { pattern: /^\d{9,10}$/, minLength: 9, maxLength: 10, message: "UAE mobile number must be 9-10 digits" },
  // Saudi Arabia - 9 digits, starts with 5
  "Saudi Arabia": { pattern: /^5\d{8}$/, minLength: 9, maxLength: 9, message: "Saudi mobile number must be 9 digits and start with 5" },
  // Canada - 10 digits
  "Canada": { pattern: /^\d{10}$/, minLength: 10, maxLength: 10, message: "Canadian mobile number must be 10 digits" },
  // Australia - 9 digits
  "Australia": { pattern: /^\d{9,10}$/, minLength: 9, maxLength: 10, message: "Australian mobile number must be 9-10 digits" },
  // Germany - 10-11 digits
  "Germany": { pattern: /^\d{10,11}$/, minLength: 10, maxLength: 11, message: "German mobile number must be 10-11 digits" },
  // France - 9-10 digits
  "France": { pattern: /^\d{9,10}$/, minLength: 9, maxLength: 10, message: "French mobile number must be 9-10 digits" },
  // Default - 8-15 digits (international standard)
  default: { pattern: /^\d{8,15}$/, minLength: 8, maxLength: 15, message: "Mobile number must be 8-15 digits" }
};


export {
  getInterviewStatus,
  getRangeDateTimeString,
  getFilterStatus,
  bytesToMB,
  fetchBasicAdminDetails,
  fetchAdminClientCreds,
  renderQualificationWithSpecialization,
  phoneValidationRules,
};
